angular.module('Itao.IndicatorMap').directive('setBarChart', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var hideLegendScale = [];

  var sortedAccessor = function (d, i) {
    return i;
  };
  var combineData = function (layer, setIndicators, disabledDistrictKeys, disabledListIndex, colorset, legend) {
    var indicatorsWithoutLists = setIndicators;
    hideLegendScale = [];
    var numberOfDistricts = Object.keys(layer.districts).length;
    //var valueCheck = Object.keys(layer.districts).map(function () {
    //  return indicatorsWithoutLists.map(function() {
    //    return 0;
    //  });
    //});

    var valueCheck = indicatorsWithoutLists.map(function () {
      //return Object.keys(layer.districts).map(function () {
      //  return 0;
      //});
      return 0;
    });

    return Object.keys(layer.districts).filter(function (districtUid) {
      return disabledDistrictKeys.indexOf(layer.districts[districtUid].key) === -1;
    }).map(function (districtUid) {
      var valueArray = indicatorsWithoutLists.map(function (indicator, index) {
        var indicatorName = indicator.name;
        if (legend != null) {
          if (legend.chart.scales.hasOwnProperty(index)) {
            indicatorName = legend.chart.scales[index].text;
          } else {
            console.warn('Scale is missing index ' + index + '. Using ' + indicatorName + ' instead.');
          }
        }
        var value = 0;
        if (layer[districtUid] && layer[districtUid].hasOwnProperty(indicator.uid) && layer[districtUid][indicator.uid] !== null) {
          value = layer[districtUid][indicator.uid];
        } else {
          value = null;
          valueCheck[index]++;
        }

        return {
          value: value,
          key: indicator.key,
          color: colorset[index % colorset.length],
          name: indicatorName,
          unit: indicator.unit,
          prefix: indicator.prefix
        };
      });/*.filter(function (item, idx) {
        return disabledListIndex.indexOf(idx) === -1;
      });*/

      return {
        key: layer.districts[districtUid].key,
        name: layer.districts[districtUid].name,
        hasNoGeoData: layer.districts[districtUid].hasNoGeoData,
        values: valueArray
      };
    }).map(function (districtItem) {
      districtItem.values = districtItem.values.filter(function (valueArray, valueIndex) {
        if (valueCheck[valueIndex] !== numberOfDistricts) {
          return disabledListIndex.indexOf(valueIndex) === -1;
        } else {
          hideLegendScale.push(valueIndex);
          return false;
        }
      });
      return districtItem;
    });
  };

  var calculateMaxValue = function (data) {
    return d3.max(data.map(function (current) {
      return d3.max(current.values, accessor('value'));
    }));
  };

  var calculateMinValue = function (data) {
    return d3.min(data.map(function (current) {
      return d3.min(current.values, accessor('value'));
    }));
  };

  var setBarChart = function () {
    var indicators = [],
      disabledIndicators = [],
      districtLabelProperty = 'key',
      svgHeight = 200,
      displayValues = false,
      color = d3.hyperion.indicatorColorAt,
      margin = {top: 40, right: 10, bottom: 40, left: 50},
      duration = 400,
      redLines = null,
      numberFormat = germanNumberFormat(',.2f'),
      decimals,
      maxAxisValue,
      tip;

    var chart = function (selection) {
      selection.each(function (data) {
        //calculate min and max values and check that 0 is included
        var minValue = calculateMinValue(data);
        var maxValue = calculateMaxValue(data);
        if (minValue > 0) {
          minValue = 0;
        }
        if (maxValue < 0) {
          maxValue = 0;
        }

        if (mapConfig.axisMaxValue != null) {
          maxValue = mapConfig.axisMaxValue;
        }

        var axisFormatString = ',.' + (decimals ? decimals : (maxValue < 7 ? '1' : '0')) + 'f';

        //calculate the space needed for the y-axis labels
        var labelDigits = Math.max((indicators[0].prefix + germanNumberFormat(axisFormatString)(Math.round(maxValue))).length, (indicators[0].prefix + germanNumberFormat(axisFormatString)(Math.round(minValue))).length);
        margin.left = 20 + 10 * labelDigits;

        var districtLabelDigits = d3.max(data.map(function (d) {
          return accessor(districtLabelProperty)(d).length;
        }));
        margin.bottom = 15 + 7 * districtLabelDigits;

        margin.bottom = Math.min(svgHeight / 2, margin.bottom);

        var container = d3.select(this).datum([data]).classed('bar-chart', true);

        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if (angular.isDefined(tip)) {
          tip.destroy();
        }

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, indicatorNumber, districtNumber) {
            var district = data[districtNumber], value;
            if(!decimals) {
              decimals = d.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }
            if (d.unit === '%') {
              value = d.prefix + germanNumberFormat(',.' + decimals + 'f')(d.value) + '%';
            } else {
              value = d.prefix + germanNumberFormat(',.' + decimals + 'f')(d.value);
            }
            return '<div class="d3-tip-border" style="border-color:' + d.color + ';"><b>' + district.name + ' (' + district.key + ')</b><br><span>' + d.name.replace(/<[^>]*>?/gm, '').trim() + ':</span> <span class="tooltip-value">' + value + '</span></div>';
          });

        // var redLines = mapConfig.redLines.filter(function(lineValue) { return lineValue <= maxValue; });
        redLines = redLines ? redLines : mapConfig.redLines.filter(function (lineValue) {
          return lineValue <= maxValue;
        });

        var svg = container.selectAll('svg').data([data]);

        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        // scale for districts
        var x0 = d3.scale.ordinal()
          .rangeRoundBands([0, width], 0.3)
          .domain(data.map(accessor(districtLabelProperty)));

        // scale for each bar per district
        var x1 = d3.scale.ordinal()
          .domain(data[0].values.length < 2 ? [0] : d3.range(data[0].values.length)) // use only active indicators
          .rangeRoundBands([0, x0.rangeBand()]);

        // scale for bar values
        var y = d3.scale.linear()
          .range([height, 0])
          .domain([minValue, maxAxisValue ? maxAxisValue : maxValue])
          .nice();

        var tickCount = Math.min(svgHeight / 40, 10);

        g.call(d3.hyperion.addHorizontalGridLines(y, width, 0, tickCount, duration));
        g.call(d3.hyperion.addHorizontalHighlightArea(redLines, y, x0, width, duration));

        var xAxis = d3.svg.axis()
          .scale(x0)
          .orient('bottom');

        var yAxis = d3.svg.axis()
          .scale(y)
          .orient('left')
          .ticks(tickCount)
          .tickFormat(function (d) {
            return indicators[0].prefix + germanNumberFormat(axisFormatString)(d);
          });

        gEnter.append('g')
          .attr('class', 'x axis');

        g.select('.x.axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis)
          .selectAll('text')
          .data(data)
          .style('text-anchor', districtLabelDigits > 4 ? 'end' : 'middle')
          .style('font-weight', function (d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .style('fill', function (d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : '#000';
          })
          .attr('dx', districtLabelDigits > 4 ? '-.8em' : '')
          .attr('dy', '.15em')
          .attr('transform', districtLabelDigits > 4 ? 'rotate(-65)' : '');

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .transition().duration(duration)
          .call(yAxis);

        // only draw bars if indicators are left
        if (angular.isArray(indicators) && indicators.length > 0) {

          var unit = indicators[0].unit;

          svgEnter.append('text')
            .attr('class', 'axis-unit-label')
            .attr('text-anchor', 'end')
            .attr('transform', 'translate(' + (margin.left - 7) + ', 10)');

          svg.select('.axis-unit-label')
            .text(unit === '%' ? 'in %' : '');

          // create a feature per district
          var features = g.selectAll('.feature')
            .data(data, accessor('key'));

          features
            .enter().append('g')
            .classed('feature', true)
            .attr('stroke', 'black');

          features
            .attr('transform', function (d) {
              return 'translate(' + x0(d[districtLabelProperty]) + ')';
            })
            .attr('stroke-width', function (d) {
              return accessor('selected')(d) ? '2px' : '0px';
            });

          var bars = features.selectAll('rect')
            .data(accessor('values'), accessor('key'));

          // draw new bars
          bars
            .enter()
            .append('rect')
            .style('fill', accessor('color'))
            .attr('width', 0)
            .attr('x', compose(x1, sortedAccessor))
            .attr('y', y(0))
            .attr('height', 0);

          // update all bars
          bars
            .transition().duration(duration)
            .style('fill', accessor('color'))
            .attr('width', x1.rangeBand())
            .attr('x', compose(x1, sortedAccessor))
            .attr('y', function (d) {
              return y(Math.max(0, Math.min(maxValue, accessor('value')(d))));
            })
            .attr('height', function (d) {
              return Math.abs(y(0) - y(Math.min(maxValue, accessor('value')(d))));
            });

          // add tooltips to bars
          bars.call(tip);
          bars.on('mouseover', tip.show)
            .on('mouseout', tip.hide);

          // remove unused bars
          bars.exit().transition().duration(duration)
            .attr('width', 0)
            .attr('y', y(0))
            .attr('height', function () {
              return height - y(0);
            })
            .remove();
          features.exit().remove();

          var labels = features.selectAll('text')
            .data(accessor('values'), accessor('key'));

          g.selectAll('line.highlightLine').remove();
          g.call(d3.hyperion.addHorizontalHighlightLines(redLines, y, width, duration));

          if (displayValues) {
            labels.enter()
              .append('text')
              .attr('class', 'chart-value')
              .attr('y', 0);

            // update labels
            labels
              .text(function (d) {
                return germanNumberFormat('.' + mapConfig.absoluteIndicatorsDecimalPlaces + 'f')(accessor('value')(d));
              })
              .attr('x', function (d, i) {
                return (x1.rangeBand() / 2) + (x1.rangeBand() * i);
              })
              .attr('y', function (d) {
                return y(Math.max(0, accessor('value')(d))) - 4;
              });
            // remove unused labels
            labels.exit()
              .remove();
          } else {
            labels
              .remove();
          }

        } else {
          // remove all bars if no indicators are active
          g.selectAll('rect').remove();
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    chart.indicators = function (newIndicators) {
      if (!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for disabledIndicators
     * @param {int} [newDisabledIndicators] set of disabled indicators
     * @returns {*}
     */
    chart.disabledIndicators = function (newDisabledIndicators) {
      if (!arguments.length) {
        return disabledIndicators;
      } else {
        disabledIndicators = newDisabledIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for districtLabelProperty
     * @param {string} [districtLabelProperty] name of property to use for districtlabels
     * @returns {*}
     */
    chart.districtLabelProperty = function (newdistrictLabelProperty) {
      if (!arguments.length) {
        return districtLabelProperty;
      } else {
        districtLabelProperty = newdistrictLabelProperty;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for color
     * @param {Function} [newColor] new color function
     * @returns {*}
     */
    chart.color = function (newColor) {
      if (!arguments.length) {
        return color;
      } else {
        color = newColor;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDisplayValues] height of the diagram
     * @returns {*}
     */
    chart.displayValues = function (newDisplayValues) {
      if (!arguments.length) {
        return displayValues;
      } else {
        displayValues = newDisplayValues;
        return chart;
      }
    };

    /**
     * getter/setter for redLines
     * @param {Function} [newRedLines] new redLines function
     * @returns {*}
     */
    chart.redLines = function (newRedLines) {
      if (!arguments.length) {
        return redLines;
      } else {
        redLines = newRedLines;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };


    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element) {
    return element.closest('.grid-stack-item-content-setBarChart').height() - jQuery(element).find('chart-indicator-legend').height() - 10;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'setBarChart.html',
    scope: {
      layer: '=',
      disabledDistrictKeys: '=',
      disabledListIndex: '=',
      colorsets: '=',
      indicators: '=',
      indicatorSets: '=',
      dimensionX: '@',
      dimensionY: '@',
      config: '='
    },
    link: function (scope, element) {
      scope.config.disabledIndicators = scope.config.disabledIndicators || [];
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.config.fullscreen = scope.config.fullscreen || false;
      scope.config.displayValues = scope.config.displayValues || false;

      var setBarChartFunction = setBarChart();

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if (Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }
        if (newHeight == null) {
          newHeight = calculateChartHeight(element);
        }

        var indicators = scope.indicators;
        var redLines;
        scope.selectedIndicatorSet = [];

        if (angular.isArray(indicators) && indicators.length > 0 && indicators[0].isDefault) {
          // first selected indicator belongs to an indicatorSet
          var selectedSets = scope.indicatorSets.filter(function (set) {
            return set.uid === indicators[0].type;
          });
          if (selectedSets.length > 0) {
            scope.selectedIndicatorSet = selectedSets[0];
            scope.config.selectedIndicatorSet = selectedSets[0].uid;

            var defaultIndicatorUid = (+scope.selectedIndicatorSet.defaultIndicator.uid);
            var colorset = d3.hyperion.indicatorColors;
            var legend = null;
            var decimals,
              maxAxisValue;
            if (scope.layer.legend != null && scope.layer.legend.hasOwnProperty(defaultIndicatorUid) && scope.layer.legend[defaultIndicatorUid].chart != null) {
              colorset = scope.colorsets.filter(function (colorset) {
                return (+colorset.uid) === (+scope.layer.legend[defaultIndicatorUid].chart.colorSet);
              })[0].colors.map(function (color) {
                return color.color;
              });
              legend = scope.layer.legend[defaultIndicatorUid];


              if (legend.chart && legend.chart.decimals !== null) {
                decimals = legend.chart.decimals;
              }

              if (legend.chart && legend.chart.maxAxisValue) {
                maxAxisValue = legend.chart.maxAxisValue;
              }

              if (legend.chart && legend.chart.redLines) {
                redLines = legend.chart.redLines;
              }
            }

            var setIndicators = scope.selectedIndicatorSet.indicators.filter(function (indicator, idx) {
              return indicator.list === false;
            }).sort(function (a, b) {
              return a.listIndex - b.listIndex;
            });

            if (scope.disabledListIndex.length !== setIndicators.length) {
              var data = combineData(scope.layer, setIndicators, scope.disabledDistrictKeys, scope.disabledListIndex, colorset, legend);

              if (legend.chart && legend.chart.scales) {
                legend.chart.scales.forEach(function (scale, idx) {
                  scale.disabled = hideLegendScale.indexOf(idx) > -1;
                });
              }

              setBarChartFunction
                .indicators(setIndicators)
                .districtLabelProperty(scope.config.districtLabelProperty)
                .disabledIndicators(scope.config.disabledIndicators)
                .displayValues(scope.config.displayValues)
                .redLines(redLines)
                .decimals(decimals)
                .maxAxisValue(maxAxisValue)
                .height(newHeight);

              d3.select(element.find('.widget-inner:first')[0])
                .data([data])
                .call(setBarChartFunction);
            } else {
              removeChart();
            }
          } else {

            removeChart();
          }
        }
      };

      var removeChart = function () {
        scope.config.selectedIndicatorSet = null;
        d3.select(element[0]).select('svg').remove();
      };

      jQuery(document).on("fullscreen", rerender);

      var layerWatcher = scope.$watchCollection('layer', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var colorsetsWatcher = scope.$watchCollection('colorsets', rerender);
      var indicatorSetWatcher = scope.$watchCollection('indicatorSets', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var districtLabelPropertyWatcher = scope.$watch('config.districtLabelProperty', rerender);
      var selectedIndicatorSet = scope.$watch('indicatorSetToShow', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var disabledListIndexWatcher = scope.$watchCollection('disabledListIndex', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);
      var displayValuesWatcher = scope.$watch('config.displayValues', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });
      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        indicatorSetWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        selectedIndicatorSet();
        districtLabelPropertyWatcher();
        fullscreenWatcher();
        colorsetsWatcher();
        disabledDistrictKeysWatcher();
        displayValuesWatcher();
        disabledListIndexWatcher();

        // remove tooltip dom element
        if (angular.isDefined(setBarChartFunction.tip())) {
          setBarChartFunction.tip().destroy();
        }
      });
    }
  };
});
